<template>
  <div id="contenedor-eliminar-contrato-directorio">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar persona del directorio </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la Persona? </span>
        <v-divider></v-divider>
        <v-row>
          <span class="font-weight-bold">
            {{directorioEliminar.nombre}}
          </span>
        </v-row>
         <v-row>
          <span> {{directorioEliminar.puesto}}
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="botonEliminarDirectorio"
          :disabled="enviandoFormulario || $apollo.loading"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixDirectorios from './mixDirectorios';

export default {
  name: 'ContenedorEliminarContratoDirectorio',
  props: {
    directorioEliminar: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixDirectorios],
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    botonEliminarDirectorio() {
      this.mixEliminarDirectorio();
    },
  },
};
</script>
